export const getUser = () => {
    const user = localStorage.getItem('userDetails');
    return user ? JSON.parse(user) : null;
  };
  
  export const getPermissions = () => {
    const direct = localStorage.getItem("permissions");
    if (direct) return JSON.parse(direct);
  
    const user = getUser();
    return user?.permissions || [];
    
  };
  
  export const hasPermission = (perm) => {
    const perms = getPermissions();
    return perms.includes(perm);
  };
  
  export const getFieldAccess = () => {
    const user = getUser();
    return user?.fieldsAccess || [];
  };
  
  export const canAccessField = (fieldName) => {
    const accessList = getFieldAccess();
    return accessList.includes(fieldName);
  };
  